export const REQUEST_API_AUTH = "REQUEST_API_AUTH";
export const RECEIVE_API_DATA = "RECEIVE_API_DATA"

export const STOP_LOADING = "STOP_LOADING";
export const REQUEST_API_SSO_TOKEN = "REQUEST_API_SSO_TOKEN";
export const REQUEST_API_GUEST_MAIL = "REQUEST_API_GUEST_MAIL";
export const REQUEST_API_GUEST = "REQUEST_API_GUEST";
export const REQUEST_API_GUESTS = "REQUEST_API_GUESTS";
export const REQUEST_API_ADD_GUEST = "REQUEST_API_ADD_GUEST";
export const REQUEST_API_ADD_GUEST_SPONSOR = "REQUEST_API_ADD_GUEST_SPONSOR";
export const REQUEST_API_ADD_EVENT = "REQUEST_API_ADD_EVENT";

export const REQUEST_API_CONFIRM_BY_SPONSOR = "REQUEST_API_CONFIRM_BY_SPONSOR";
export const REQUEST_API_CONFIRM_BY_GUEST = "REQUEST_API_CONFIRM_BY_GUEST";
export const REQUEST_API_CONFIRM_SPONSOR = "REQUEST_API_CONFIRM_SPONSOR";
export const REQUEST_API_CONFIRM_GUEST = "REQUEST_API_CONFIRM_GUEST";

export const REQUEST_HEALTH_CHECK = "REQUEST_HEALTH_CHECK";

export const requestApiAuth = (data) => ({ type: REQUEST_API_AUTH, data });
export const receiveApiData = (data) => ({ type: RECEIVE_API_DATA, data });
export const requestApiSsoToken = (data) => ({ type: REQUEST_API_SSO_TOKEN, data });

export const requestApiGuestMail = (data) => ({ type: REQUEST_API_GUEST_MAIL, data });
export const requestApiGuest = (data) => ({ type: REQUEST_API_GUEST, data });
export const requestApiGuests = (data) => ({ type: REQUEST_API_GUESTS, data });
export const requestApiAddGuestByGuest = (data) => ({ type: REQUEST_API_ADD_GUEST, data });
export const requestApiAddGuestBySponsor = (data) => ({ type: REQUEST_API_ADD_GUEST_SPONSOR, data });
export const requestApiAddEvent = (data) => ({ type: REQUEST_API_ADD_EVENT, data });

export const requestApiValidateBySponsor = (data) => ({ type: REQUEST_API_CONFIRM_BY_SPONSOR, data });
export const requestApiValidateByGuest = (data) => ({ type: REQUEST_API_CONFIRM_BY_GUEST, data });
export const requestApiValidateSponsor = (data) => ({ type: REQUEST_API_CONFIRM_SPONSOR, data });
export const requestApiValidateGuest = (data) => ({ type: REQUEST_API_CONFIRM_GUEST, data });

export const cancelLoading = () => ({ type: STOP_LOADING });

export const requestHealthCheck = () => ({ type: REQUEST_HEALTH_CHECK });
